import React, { Component } from 'react'
import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
// import './assets/react-select.css'
import moment from 'moment';
import { connect } from 'react-redux'
import { updateSettings } from '../actions/userActions'

@connect((store)=>{
  return {
    currentSettings: store.user.currentSettings,
    fetching: store.user.fetching
  } 
})
class Filters extends Component {

handleSearch = (e) => {
  let string = e.target.value.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
  if (e.key === 'Enter') {
    this.props.dispatch(updateSettings({...this.props.currentSettings,search:string}))
  }
}

handleInicio = (selectedOption) => {
  this.props.dispatch(updateSettings({...this.props.currentSettings, inicio:new Date(selectedOption)}))
}

handleFim = (selectedOption) => {
  this.props.dispatch(updateSettings({...this.props.currentSettings, fim:new Date(selectedOption)}))
}

handleConta = (selectedOption) => {
  this.props.dispatch(updateSettings({...this.props.currentSettings, conta:selectedOption}))
}

handleProcessado = (selectedOption) => {
  this.props.dispatch(updateSettings({...this.props.currentSettings, processado:selectedOption}))
}

handleTags = (selectedOption) => {
  this.props.dispatch(updateSettings({...this.props.currentSettings, tags:selectedOption}))
}

  render() {

  let contas = this.props.transactions.map(x => {
      return x.conta
    })

  let uniqueContas = [...new Set(contas.map(item => item
   ))].map(x=>{
     return {value:x,label:x}
   })

  let unique = (arrArg) => {
    return arrArg.filter((elem, pos, arr) => {
      return arr.indexOf(elem) === pos;
    });
  }

  let allTags = this.props.transactions.reduce((int,x)=>{
      int.push(...x.tags)
      return unique(int)
    },[]).map(x=>{
      return {label:x,value:x}
    })
  
    
    return (
        <div className="filters">
        <div>
        <span className="filter-title">Busca:</span><br/>
          <input className="selectcustom" type="text" defaultValue={this.props.currentSettings.search} 
          onKeyPress={this.handleSearch}
          />
        </div>
        <div>
        <span className="filter-title">Início:</span>
        <DatePicker
          todayButton={"Hoje"}
          selected={moment(this.props.currentSettings.inicio)}
          onChange={this.handleInicio}
        /></div>
        <div>
        <span className="filter-title">Fim:</span>
        <DatePicker
          todayButton={"Hoje"}
          selected={moment(this.props.currentSettings.fim)}
          onChange={this.handleFim}
        /></div>
        <div>
        <span className="filter-title">Tags:</span>
        <div className="selectcustom"><Select
        multi
        name="tags"
        value={this.props.currentSettings.tags}
        onChange={this.handleTags}
        options={[{ value: 'todas', label: 'Todas' },...allTags]}
        clearable={true}
      /></div></div>
        <div>
        <span className="filter-title">Contas:</span>
        <div className="selectcustom"><Select
        multi
        value={this.props.currentSettings.conta}
        options={[{ value: 'todas', label: 'Todas' },...uniqueContas]}
        name="conta"
        onChange={this.handleConta}
        clearable={false}
      /></div></div>
        <div>
        <span className="filter-title">Processado:</span>
        <div className="selectcustom"><Select
        value={this.props.currentSettings.processado}
        name="processado"
        onChange={this.handleProcessado}
        clearable={false}
        options={[
          { value: 'todos', label: 'Todos' },
          { value: 'sim', label: 'Sim' },
          { value: 'nao', label: 'Não' }
        ]}
      /></div></div>
      </div>
    );
  }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/components/Filters.js